import { useNavigate } from 'react-router-dom';
import Logo from '@/components/feature/Logo';
import { useAppDownload } from '@/context/AppDownloadContext';

function DownloadAppFooterBtn() {
  const { openModal } = useAppDownload();
  return (
    <button
      onClick={openModal}
      className="w-full sm:w-auto px-4 py-2.5 rounded-lg bg-accent-500 hover:bg-accent-600 text-background-50 dark:text-foreground-950 text-sm font-semibold cursor-pointer transition-colors whitespace-nowrap"
    >
      <i className="ri-download-2-line mr-1.5"></i>
      Descargar App
    </button>
  );
}

export default function Footer() {
  const navigate = useNavigate();
  const { openModal } = useAppDownload();
  const footerLinks = {
    navegacion: [
      { label: 'Inicio', href: '#inicio' },
      { label: 'Explorar Radios', href: '#explorar' },
      { label: 'Rankings RFW', href: '/rankings' },
      { label: 'Eventos', href: '/eventos' },
      { label: 'Clubes', href: '/clubes' },
      { label: 'Competencias', href: '/competencias' },
    ],
    legal: [
      { label: 'Privacidad', href: '/privacy' },
      { label: 'Términos', href: '/terms' },
      { label: 'Cookies', href: '/cookies' },
      { label: 'Reglas de Radio', href: '/radio-rules' },
    ],
  };

  const handleClick = (href: string) => {
    if (href.startsWith('#')) {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else if (href.startsWith('/')) {
      navigate(href);
    }
  };

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-2/5">
            <a href="#inicio" onClick={(e) => { e.preventDefault(); handleClick('#inicio'); }} className="flex items-center mb-5 cursor-pointer">
              <Logo size="xl" />
            </a>
            <p className="text-foreground-300 text-base leading-relaxed max-w-md">
              La comunidad de radio más grande del mundo. Donde radios, locutores, programas, clubes y oyentes se encuentran, comparten y crecen juntos.
            </p>
            <div className="flex items-center gap-3 mt-6">
              {['ri-facebook-fill', 'ri-twitter-x-fill', 'ri-instagram-line', 'ri-youtube-fill'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-700 hover:border-primary-500 hover:text-primary-400 text-foreground-400 transition-all duration-200 cursor-pointer"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="lg:w-1/5">
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-5">Navegación</h4>
            <ul className="space-y-3">
              {footerLinks.navegacion.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleClick(link.href); }}
                    className="text-foreground-300 hover:text-background-50 transition-colors duration-200 text-sm cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:w-1/5">
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-5">Legal</h4>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-foreground-300 hover:text-background-50 transition-colors duration-200 text-sm cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:w-1/5">
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-5">App</h4>
            <DownloadAppFooterBtn />
            <ul className="space-y-3 text-foreground-300 text-sm mt-4">
              <li>contacto@radiofrecuenciaweb.com</li>
              <li>+1 (555) 123-4567</li>
              <li>Santa Rosa, California</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} RadioFrecuenciaWeb. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6">
            <a href="/privacy" onClick={(e) => { e.preventDefault(); navigate('/privacy'); }} className="text-foreground-500 hover:text-background-50 text-xs transition-colors cursor-pointer">Privacidad</a>
            <a href="/terms" onClick={(e) => { e.preventDefault(); navigate('/terms'); }} className="text-foreground-500 hover:text-background-50 text-xs transition-colors cursor-pointer">Términos</a>
            <a href="/radio-rules" onClick={(e) => { e.preventDefault(); navigate('/radio-rules'); }} className="text-foreground-500 hover:text-background-50 text-xs transition-colors cursor-pointer">Reglas</a>
            <a href="/cookies" onClick={(e) => { e.preventDefault(); navigate('/cookies'); }} className="text-foreground-500 hover:text-background-50 text-xs transition-colors cursor-pointer">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}